module.exports = __webpack_public_path__ + "img/early-warning-1.be529b37.gif";